(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-finder"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('gtf-finder')){customElements.define('gtf-finder',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.step=0;this.form=this.querySelector('form');this.panels=[...this.querySelectorAll('[data-step]')];this.result=this.querySelector('[data-result]');this.msg=this.querySelector('[data-messages]').dataset;this.detailsHeading=this.panels[2].querySelector('h2');this.connectionTitle=this.detailsHeading.textContent;this.querySelectorAll('[data-next]').forEach(b=>b.addEventListener('click',()=>{if(this.step===1&&!this.form.elements.brand.reportValidity())return;this.show(this.step+1);}));this.querySelectorAll('[data-back]').forEach(b=>b.addEventListener('click',()=>this.show(this.step-1)));this.form.addEventListener('submit',e=>{e.preventDefault();if(this.step<2){if(this.step!==1||this.form.elements.brand.reportValidity())this.show(this.step+1);return;}this.renderResult();});this.querySelector('[data-edit]').addEventListener('click',()=>this.show(0));this.querySelector('[data-reset]').addEventListener('click',()=>{this.form.reset();this.show(0);});this.querySelector('[data-copy]').addEventListener('click',async()=>{let manual=this.querySelector('[data-copy-fallback]');manual.hidden=false;manual.value=this.summaryText;manual.focus();manual.select();this.querySelector('[data-copy-status]').textContent=this.msg.copyFailed;try{await navigator.clipboard.writeText(this.summaryText);this.querySelector('[data-copy-status]').textContent=this.msg.copied;}catch{let field=this.querySelector('[data-copy-fallback]');field.hidden=false;field.value=this.summaryText;field.focus();field.select();this.querySelector('[data-copy-status]').textContent=this.msg.copyFailed;}});}
show(n){this.step=Math.max(0,Math.min(2,n));this.form.hidden=false;this.result.hidden=true;this.panels.forEach((p,i)=>p.hidden=i!==this.step);this.querySelectorAll('.gf-steps li').forEach((li,i)=>{li.classList.toggle('is-done',i<this.step);if(i===this.step)li.setAttribute('aria-current','step');else li.removeAttribute('aria-current');});let filter=this.form.elements.part.value==='filter';this.querySelector('[data-connections]').hidden=filter;this.querySelector('[data-filter]').hidden=!filter;this.querySelector('.gf-aside').hidden=filter;this.querySelector('.gf-layout').classList.toggle('gf-filter',filter);this.detailsHeading.textContent=filter?this.form.querySelector('input[name="part"]:checked').closest('label').querySelector('strong').textContent:this.connectionTitle;this.panels[this.step].querySelector('h2').focus({preventScroll:true});this.panels[this.step].scrollIntoView({block:'nearest',behavior:'instant'});}
renderResult(){let f=this.form.elements,m=this.msg,filter=f.part.value==='filter',model=f.model.value.trim(),normal=model.toLowerCase().replace(/[^a-z0-9]/g,'');let known=f.brand.value==='kaercher'&&f.part.value==='hose'&&['k555jubilee','kaercherk555jubilee','krcherk555jubilee'].includes(normal);let conflict=known&&((f.a.value!=='unknown'&&f.a.value!=='m22ig')||(f.b.value!=='unknown'&&f.b.value!=='qc'));let both=f.a.value==='m22ig'&&f.b.value==='qc';let hasProduct=this.querySelector('[data-product] .gf-product');let candidate=known&&!conflict&&hasProduct;this.querySelector('[data-result-title]').textContent=candidate?(both?m.foundTitle:m.uncertainTitle):m.noneTitle;this.querySelector('[data-result-description]').textContent=conflict?m.conflictBody:candidate?(both?m.foundBody:m.uncertainBody):m.noneBody;this.querySelector('[data-product]').hidden=!candidate;this.querySelectorAll('[data-hose-check]').forEach(x=>x.hidden=filter);this.querySelector('[data-filter-check]').hidden=!filter;let part=this.form.querySelector('input[name="part"]:checked').closest('label').querySelector('strong').textContent;let rows=[[m.part,part],[m.brand,f.brand.selectedOptions[0].textContent],[m.model,model||m.notGiven]];if(filter)rows.push([m.ref,f.reference.value.trim()||m.notGiven]);else rows.push([m.a,f.a.selectedOptions[0].textContent],[m.b,f.b.selectedOptions[0].textContent]);let summary=this.querySelector('[data-summary]');summary.replaceChildren();rows.forEach(([label,value])=>{let row=document.createElement('div'),dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;row.append(dt,dd);summary.append(row);});this.summaryText=m.subject+String.fromCharCode(10,10)+rows.map(r=>r.join(': ')).join(String.fromCharCode(10));this.querySelector('[data-email]').href='mailto:m2m.anfrage@gmail.com?subject='+encodeURIComponent(m.subject)+'&body='+encodeURIComponent(this.summaryText);this.querySelector('[data-copy-status]').textContent='';this.querySelector('[data-copy-fallback]').hidden=true;this.form.hidden=true;this.result.hidden=false;this.querySelectorAll('.gf-steps li').forEach(li=>{li.removeAttribute('aria-current');li.classList.add('is-done');});this.result.querySelector('h2').focus({preventScroll:true});this.result.scrollIntoView({block:'start',behavior:'instant'});}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-withdrawal"] && !Shopify.designMode) return;
  try {
    
(()=>{'use strict';function init(){document.querySelectorAll('[data-withdrawal-preview]').forEach(form=>{if(form.dataset.initialized)return;form.dataset.initialized='true';form.addEventListener('submit',event=>event.preventDefault());const button=form.querySelector('[data-preview-withdrawal]');button.addEventListener('click',()=>{if(!form.reportValidity())return;const summary=form.querySelector('[data-withdrawal-summary]');summary.querySelector('[data-withdraw-name]').textContent=form.elements.consumer_name.value;summary.querySelector('[data-withdraw-contract]').textContent=form.elements.contract_details.value;summary.querySelector('[data-withdraw-email]').textContent=form.elements.confirmation_email.value;summary.hidden=false;summary.focus();});});}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{once:true});}else{init();}document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
